<mat-table mat-table [dataSource]="dataSource">
  <!--  History cell -->
  <ng-container [matColumnDef]="'history'">
    <mat-header-cell mat-header-cell *matHeaderCellDef> history </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let historyElem">
      <o-orion-card
        [class.selected-node]="historyElem.dmc === dmcSelected"
        [data]="historyElem | orionCardFormatter: orionCardSource.HISTORY"
        [routerLink]="historyElem.dmc | getDUUrl"
        (click)="historyElem.dmc !== dmcSelected && emitClose(historyElem)">
        <div class="time" action-left>
          {{ historyElem.date | date: "shortTime" : "" : store.currentLanguage }}
        </div>
      </o-orion-card>
    </mat-cell>
  </ng-container>

  <!--  Date cell -->
  <ng-container [matColumnDef]="'group'">
    <mat-header-cell mat-header-cell *matHeaderCellDef> group </mat-header-cell>
    <mat-cell mat-cell class="section" *matCellDef="let date">
      <h4 class="date">{{ date }}</h4>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="['history']"></mat-header-row>
  <mat-row *matRowDef="let row; columns: ['history']"></mat-row>

  <mat-header-row *matHeaderRowDef="['group']"></mat-header-row>
  <mat-row *matRowDef="let row; columns: ['group']; when: isDate"></mat-row>
</mat-table>
